import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=316f9255&"
import script from "./FileBrowser.vue?vue&type=script&lang=ts&"
export * from "./FileBrowser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports